export const ON_LOAD = "ON_LOAD";
export const UPDATE_PROGRAM = "UPDATE_PROGRAM";
export const CANCEL_PROGRAM = "CANCEL_PROGRAM";
export const PROCESS_ORDER = "PROCESS_ORDER";
export const UPDATE_EMAILS = "UPDATE_EMAILS";
export const GET_MEMBERSHIPS = "GET_MEMBERSHIPS";
export const UPDATE_LOCKOUT = "UPDATE_LOCKOUT";
export const UPDATE_REPORT_DOWNLOADS = "UPDATE_REPORT_DOWNLOADS";
export const UPDATE_CALL_NOTES = "UPDATE_CALL_NOTES";
export const UPDATE_USER_DETAILS = "UPDATE_USER_DETAILS";